// Quem entra no módulo Omnichannel, e com que papel.
//
// O acesso NÃO vem de `profiles.role`: vem da tabela `inbox_members`, que é a
// mesma que a RLS do banco consulta. Com isso, liberar ou tirar alguém do
// módulo é uma linha na tabela — não um deploy.
//
// Falha fechada de propósito: enquanto não sabemos, é `false`. É melhor o item
// do menu aparecer meio segundo depois do que piscar para quem não deveria vê-lo.

import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

// observador (#6530): vê tudo, como o supervisor, e não escreve nada.
export type PapelInbox = 'agente' | 'supervisor' | 'admin' | 'observador';

export interface AcessoInbox {
  ehMembro: boolean;
  /** Gestão de conexões é só de admin: cria e derruba o canal da empresa. */
  ehAdmin: boolean;
  orgId: string | null;
  papel: PapelInbox | null;
  carregando: boolean;
}

export function useInboxMembro(userId: string | null | undefined): AcessoInbox {
  const [acesso, setAcesso] = useState<AcessoInbox>({
    ehMembro: false, ehAdmin: false, orgId: null, papel: null, carregando: true,
  });

  useEffect(() => {
    if (!userId) {
      setAcesso({ ehMembro: false, ehAdmin: false, orgId: null, papel: null, carregando: false });
      return;
    }
    let vivo = true;
    supabase
      .from('inbox_members')
      .select('org_id, role')
      .eq('user_id', userId)
      .limit(1)
      .maybeSingle()
      .then(({ data }) => {
        if (!vivo) return;
        const papel = (data?.role ?? null) as PapelInbox | null;
        setAcesso({
          ehMembro: !!data,
          ehAdmin: papel === 'admin',
          orgId: data?.org_id ?? null,
          papel,
          carregando: false,
        });
      });
    return () => { vivo = false; };
  }, [userId]);

  return acesso;
}
